(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[26],{

/***/ "3AZ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Rentals_Rentals; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/client/components/utils/layers/layers.constants.js
var layers_constants = __webpack_require__("RDfq");

// EXTERNAL MODULE: ./src/client/context/ServicesContext.js
var ServicesContext = __webpack_require__("2Odu");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/frameworks/toast/Toast.jsx
var Toast = __webpack_require__("0x7Y");

// EXTERNAL MODULE: ./src/client/components/widgets/layer/ClosableLayer.jsx
var ClosableLayer = __webpack_require__("FK6w");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngineTrackingContext.js
var BookingEngineTrackingContext = __webpack_require__("v+bK");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("3voH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/hooks/use-feature-flip/useFeatureFlip.js
var useFeatureFlip = __webpack_require__("xu+1");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/utils/measure/measure.js
var measure = __webpack_require__("yJ4S");

// CONCATENATED MODULE: ./src/client/components/widgets/easy-arrival-modal/EasyArrivalModal.jsx




var __jsx = react_default.a.createElement;












var EasyArrivalModal_EasyArrivalModal = function EasyArrivalModal(_ref) {
  var className = _ref.className,
      getOverHeight = _ref.getOverHeight,
      onEasyArrivalModalClose = _ref.onEasyArrivalModalClose;

  var _useState = Object(react["useState"])(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useMeasure = Object(measure["a" /* useMeasure */])(),
      _useMeasure2 = Object(slicedToArray["a" /* default */])(_useMeasure, 2),
      bind = _useMeasure2[0],
      height = _useMeasure2[1].height;

  var _useRouter = Object(router["useRouter"])(),
      path = _useRouter.asPath;

  var _useSelector = Object(es["e" /* useSelector */])(function (state) {
    var _state$memberSpace$ca;

    return ((_state$memberSpace$ca = state.memberSpace.cart.data) === null || _state$memberSpace$ca === void 0 ? void 0 : _state$memberSpace$ca.bookingsCart) || {};
  }),
      _useSelector$cartBook = _useSelector.cartBookings,
      cartBookings = _useSelector$cartBook === void 0 ? [] : _useSelector$cartBook;

  var showEasyArrivalModal = Object(useFeatureFlip["a" /* useFeatureFlip */])('booking.showEasyArrivalModal');
  Object(react["useEffect"])(function () {
    if (getOverHeight) {
      getOverHeight(height);
    }
  }, [height, getOverHeight]);
  var isFromBE = path.startsWith('/booking');
  var isFromCC = path.startsWith('/account');
  var hasSomethingInCart = cartBookings.some(function (_ref2) {
    var isEmpty = _ref2.isEmpty;
    return !isEmpty;
  });
  var hasMargin = isFromBE || isFromCC && hasSomethingInCart;

  if (!showEasyArrivalModal) {
    return null;
  }

  return __jsx(react["Fragment"], null, __jsx("div", Object(esm_extends["a" /* default */])({}, bind, {
    className: Object(classnames_utils["a" /* classnames */])('isolate w-[405px] max-w-[calc(100vw-40px)] rounded-12 border-1 border-solid border-lightGrey bg-white', className, {
      'mb-[140px]': hasMargin
    })
  }), __jsx("button", {
    className: "text-initial flex items-center gap-10 p-10",
    onClick: function onClick() {
      return setIsOpen(true);
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    alt: Object(i18n["h" /* t */])('stays.linkLabels.easyArrivalLabel'),
    name: icons["a" /* ICONS */].USER_DETAILS,
    width: "7rem"
  }), __jsx("span", {
    className: "text-14"
  }, __jsx("span", {
    className: "block font-brand text-16 font-bold text-sienna"
  }, Object(i18n["h" /* t */])('common.easyArrival.title')), __jsx("span", {
    className: "block"
  }, Object(i18n["h" /* t */])('common.easyArrival.description')), __jsx("span", {
    className: "block text-black underline"
  }, Object(i18n["h" /* t */])('common.learnAbout')))), __jsx("button", {
    className: "absolute end-0 top-0 m-10",
    "data-testid": "close-button",
    onClick: function onClick(e) {
      e.stopPropagation();
      onEasyArrivalModalClose();
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "0.75rem"
  }))), isOpen && __jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(i18n["h" /* t */])('common.easyArrival.info.title'),
    ariaLabelledby: constants["y" /* ID_MODAL_HEADER__EASY_ARRIVAL_INFO */],
    className: "flex flex-col items-center gap-20 p-20 text-center md:p-40",
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: function onClose() {
      return setIsOpen(false);
    },
    size: "small"
  }, __jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    name: icons["a" /* ICONS */].USER_DETAILS,
    width: "4rem"
  }), __jsx(Title["a" /* Title */], {
    id: constants["y" /* ID_MODAL_HEADER__EASY_ARRIVAL_INFO */],
    theme: "title-brand-n1"
  }, Object(i18n["h" /* t */])('common.easyArrival.info.title')), __jsx("p", null, Object(i18n["h" /* t */])('common.easyArrival.info.text')), __jsx("p", {
    className: "font-bold"
  }, Object(i18n["h" /* t */])('common.easyArrival.info.ready'))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: ./src/client/components/frameworks/columns/Columns.jsx + 1 modules
var Columns = __webpack_require__("bbEf");

// EXTERNAL MODULE: ./src/client/components/frameworks/filter-button/FilterButton.jsx
var FilterButton = __webpack_require__("Gf56");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/client/components/widgets/availability-badge/AvailabilityBadge.jsx
var AvailabilityBadge = __webpack_require__("5iTF");

// CONCATENATED MODULE: ./src/client/components/widgets/rentals-section-title/RentalsSectionTitle.jsx
var RentalsSectionTitle_jsx = react_default.a.createElement;





var RentalsSectionTitle_RentalsSectionTitle = function RentalsSectionTitle(_ref) {
  var children = _ref.children,
      className = _ref.className,
      id = _ref.id,
      _ref$isOnDemand = _ref.isOnDemand,
      isOnDemand = _ref$isOnDemand === void 0 ? false : _ref$isOnDemand;
  return RentalsSectionTitle_jsx(Title["a" /* Title */], {
    className: Object(classnames_utils["a" /* classnames */])('border-b-1 border-lightGrey justify-between', className),
    hLevel: 3,
    id: id,
    theme: "title-brand-n1"
  }, children, RentalsSectionTitle_jsx("span", {
    className: "font-sans gap-5 inline-flex shrink-0 items-center leading-1 text-14 text-black"
  }, RentalsSectionTitle_jsx(AvailabilityBadge["a" /* AvailabilityBadge */], {
    isOnDemand: isOnDemand
  }), Object(i18n["h" /* t */])(isOnDemand ? 'common.onDemand' : 'common.included')));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 2 modules
var ple_utils = __webpack_require__("6jSF");

// EXTERNAL MODULE: ./src/client/components/frameworks/feature-card/FeatureCard.jsx
var FeatureCard = __webpack_require__("OwO1");

// EXTERNAL MODULE: ./src/client/components/widgets/upsell-booking/UpsellBooking.jsx
var UpsellBooking = __webpack_require__("lOIz");

// CONCATENATED MODULE: ./src/client/components/widgets/rental-card/RentalCard.jsx





var RentalCard_jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */





var RentalCard_RentalCard = function RentalCard(_ref) {
  var bookingId = _ref.bookingId,
      className = _ref.className,
      onBook = _ref.onBook,
      rental = _ref.rental;

  var _useCartLocked = Object(ple_utils["o" /* useCartLocked */])(bookingId),
      isCartLocked = _useCartLocked.isCartLocked;

  var _useState = Object(react["useState"])(false),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  if (!rental) {
    return null;
  }

  var ageRestriction = rental.ageRestriction,
      furtherInformation = rental.furtherInformation,
      id = rental.id,
      levels = rental.levels,
      longDescription = rental.longDescription,
      name = rental.name,
      sizes = rental.sizes;
  var list = [{
    label: Object(i18n["h" /* t */])('common.age'),
    value: (ageRestriction === null || ageRestriction === void 0 ? void 0 : ageRestriction.formatted) || ''
  }, {
    label: Object(i18n["h" /* t */])('common.level'),
    value: (levels || []).map(function (l) {
      return l.label;
    }).join(' - ')
  }, {
    label: Object(i18n["h" /* t */])('common.size'),
    value: (sizes === null || sizes === void 0 ? void 0 : sizes.min) ? "".concat([sizes === null || sizes === void 0 ? void 0 : sizes.min, sizes === null || sizes === void 0 ? void 0 : sizes.max].join(' - '), " ").concat(((sizes === null || sizes === void 0 ? void 0 : sizes.unit) || '').toLowerCase()) : null
  }].filter(function (l) {
    return l.value;
  });
  return RentalCard_jsx(UpsellBooking["a" /* UpsellBooking */], {
    onBook: onBook,
    upsell: rental
  }, function (_ref2) {
    var currentPrice = _ref2.currentPrice,
        isAdded = _ref2.isAdded,
        isLoading = _ref2.isLoading,
        onExpand = _ref2.onExpand,
        onSubmit = _ref2.onSubmit;
    return RentalCard_jsx("div", {
      className: "cursor-pointer",
      onClick: function onClick() {
        setIsExpanded(!isExpanded);
        onExpand && onExpand(isExpanded);
      }
    }, RentalCard_jsx(FeatureCard["a" /* FeatureCard */], {
      className: className,
      description: longDescription,
      hasReverseLayout: true,
      isAdded: isAdded,
      isLoading: isLoading,
      isCartLocked: isCartLocked,
      id: id,
      list: list,
      name: name,
      note: furtherInformation,
      onBook: onSubmit,
      isExpanded: isExpanded,
      price: currentPrice
    }));
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/rentals-filtered-list/RentalsFilteredList.jsx



var RentalsFilteredList_jsx = react_default.a.createElement;








var INITIAL_FILTER = {
  min: 0,
  max: 1440
};
var ADULT_FILTER = {
  min: 144,
  max: 1440
};
var CHILD_FILTER = {
  min: 0,
  max: 143
};
var RentalsFilteredList_RentalsFilteredList = function RentalsFilteredList(_ref) {
  var className = _ref.className,
      _ref$colsNumber = _ref.colsNumber,
      colsNumber = _ref$colsNumber === void 0 ? 3 : _ref$colsNumber,
      id = _ref.id,
      _ref$rentals = _ref.rentals,
      rentals = _ref$rentals === void 0 ? [] : _ref$rentals,
      title = _ref.title;

  var _useState = Object(react["useState"])(INITIAL_FILTER),
      filter = _useState[0],
      setFilter = _useState[1];

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      bookingId = _useContext.bookingId;

  if (!(rentals === null || rentals === void 0 ? void 0 : rentals.length)) {
    return null;
  }

  var list = rentals.filter(function (r) {
    return r.ageRestriction.min >= filter.min && r.ageRestriction.max <= filter.max;
  }).map(function (r) {
    return RentalsFilteredList_jsx(RentalCard_RentalCard, {
      bookingId: bookingId,
      className: "mb-20",
      key: r.name,
      rental: r
    });
  });
  return RentalsFilteredList_jsx("section", {
    className: className
  }, RentalsFilteredList_jsx(RentalsSectionTitle_RentalsSectionTitle, {
    className: "mb-20",
    id: id,
    isOnDemand: true
  }, title), rentals.length > 1 && RentalsFilteredList_jsx("div", {
    className: "scroll-x scrollbar-hidden"
  }, RentalsFilteredList_jsx("ul", {
    className: "-m-5 mb-20 flex"
  }, RentalsFilteredList_jsx("li", {
    className: "p-5"
  }, RentalsFilteredList_jsx(FilterButton["a" /* FilterButton */], {
    isActive: filter === INITIAL_FILTER,
    onClick: function onClick() {
      return setFilter(INITIAL_FILTER);
    }
  }, Object(i18n["h" /* t */])('common.activities.seeAll'))), RentalsFilteredList_jsx("li", {
    className: "p-5"
  }, RentalsFilteredList_jsx(FilterButton["a" /* FilterButton */], {
    isActive: filter === ADULT_FILTER,
    onClick: function onClick() {
      return setFilter(ADULT_FILTER);
    }
  }, Object(i18n["h" /* t */])('common.adultAndTeen'))), RentalsFilteredList_jsx("li", {
    className: "p-5"
  }, RentalsFilteredList_jsx(FilterButton["a" /* FilterButton */], {
    isActive: filter === CHILD_FILTER,
    onClick: function onClick() {
      return setFilter(CHILD_FILTER);
    }
  }, Object(i18n["h" /* t */])('common.child'))))), list.length ? RentalsFilteredList_jsx(Columns["a" /* Columns */], {
    colsNumber: colsNumber
  }, list) : RentalsFilteredList_jsx(Notification["a" /* Notification */], {
    text: Object(i18n["h" /* t */])('common.rentals.noRentalsMessage')
  }));
};
// EXTERNAL MODULE: ./src/client/components/utils/activities/activities.utils.js
var activities_utils = __webpack_require__("8W+g");

// CONCATENATED MODULE: ./src/client/components/widgets/layer-rentals/LayerRentalsBody.jsx









var LayerRentalsBody_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var getCols = function getCols(isDesktop, isTablet) {
  if (isDesktop) {
    return 3;
  }

  if (isTablet) {
    return 2;
  }

  return 1;
};

var LayerRentalsBody_LayerRentalsBody = function LayerRentalsBody(_ref) {
  var image = _ref.image,
      _ref$rentalsTree = _ref.rentalsTree,
      rentalsTree = _ref$rentalsTree === void 0 ? [] : _ref$rentalsTree;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var _useState = Object(react["useState"])(0),
      overHeight = _useState[0],
      setOverHeight = _useState[1];

  var _useState2 = Object(react["useState"])(true),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var getOverHeight = function getOverHeight(height) {
    setOverHeight(height);
  };

  if (!(rentalsTree === null || rentalsTree === void 0 ? void 0 : rentalsTree.length)) {
    return null;
  }

  var cols = getCols(isDesktop, isTablet);
  var items = rentalsTree.filter(function (useCase) {
    return !!useCase.items.length;
  }).map(function (useCase) {
    return {
      header: {
        title: useCase.label
      },
      headerId: useCase.id,
      panelId: "panel-".concat(useCase.id),
      content: useCase.items.filter(function (type) {
        return !!type.items.length;
      }).map(function (type) {
        return LayerRentalsBody_jsx(RentalsFilteredList_RentalsFilteredList, {
          className: "my-40",
          colsNumber: cols,
          id: type.id,
          key: type.id,
          rentals: Object(activities_utils["h" /* sortCategoryOnDemandActivitiesByStartingPrice */])(type.items),
          title: type.label
        });
      })
    };
  });
  return LayerRentalsBody_jsx(react["Fragment"], null, LayerRentalsBody_jsx(Hero["a" /* Hero */], {
    className: "bg-darkGrey",
    size: "medium",
    url: image
  }), LayerRentalsBody_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "py-40 pb-100",
    style: _objectSpread({}, overHeight && {
      paddingBottom: overHeight + 130
    })
  }, LayerRentalsBody_jsx(Tabs["a" /* Tabs */], {
    id: "rentals",
    isContentUnmountedOnCollapse: true,
    isScrollable: true,
    items: items,
    scrollBackwardLabel: Object(i18n["h" /* t */])('common.scrollBackward'),
    scrollForwardLabel: Object(i18n["h" /* t */])('common.scrollForward'),
    message: Object(i18n["h" /* t */])('booking.activities.rentals.priceAndAvailibiltyInformations')
  }), isOpen && LayerRentalsBody_jsx(EasyArrivalModal_EasyArrivalModal, {
    className: "fixed bottom-0 left-1/2 z-1 mb-20 -translate-x-1/2 transform",
    getOverHeight: getOverHeight,
    onEasyArrivalModalClose: function onEasyArrivalModalClose() {
      return setIsOpen(false);
    }
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/layer-rentals/LayerRentals.jsx








var LayerRentals_jsx = react_default.a.createElement;

function LayerRentals_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function LayerRentals_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { LayerRentals_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { LayerRentals_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var LayerRentals_LayerRentals = function LayerRentals(_ref) {
  var forwardRef = _ref.forwardRef,
      image = _ref.image,
      layerName = _ref.layerName,
      _ref$rentalsTree = _ref.rentalsTree,
      rentalsTree = _ref$rentalsTree === void 0 ? [] : _ref$rentalsTree,
      title = _ref.title,
      tracking = _ref.tracking;

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      updateInfo = _useContext.updateInfo,
      setUpdateInfo = _useContext.setUpdateInfo;

  var beEngineTrackingContext = Object(react["useContext"])(BookingEngineTrackingContext["a" /* BookingEngineTrackingContext */]);
  var toasterRef = Object(react["useRef"])();

  if (!(rentalsTree === null || rentalsTree === void 0 ? void 0 : rentalsTree.length)) {
    return null;
  }

  var stateTracking = tracking || {
    pageName: tracking_constants["H" /* TRACK_PAGE_NAMES */].BE_LAYER_SKI_ACTIVITIES,
    payload: LayerRentals_objectSpread({}, beEngineTrackingContext)
  };

  var header = LayerRentals_jsx(Title["a" /* Title */], {
    className: "w-full justify-center",
    id: constants["j" /* ID_LAYER_HEADER__CA__RENTALS */],
    theme: "title-brand-n4"
  }, title);

  return LayerRentals_jsx(ClosableLayer["a" /* ClosableLayer */], {
    ariaLabel: title,
    ariaLabelledby: constants["j" /* ID_LAYER_HEADER__CA__RENTALS */],
    bgColor: colors["a" /* COLORS */].WHITE,
    externalFocusTrapRefs: [forwardRef, toasterRef],
    hasAnimateEnter: true,
    header: header,
    name: layerName || layers_constants["h" /* LAYER_NAME_UPSELL_RENTALS */],
    params: ['id', 'catId', 'stayId'],
    tracking: stateTracking
  }, LayerRentals_jsx(Toast["a" /* Toast */], {
    color: colors["a" /* COLORS */].SIENNA,
    isFixed: true,
    onClose: function onClose() {
      return setUpdateInfo && setUpdateInfo(null);
    },
    portalName: Portal_constants["b" /* AFTER_APP */],
    ref: toasterRef,
    visible: !!updateInfo
  }, LayerRentals_jsx("span", {
    className: "flex items-center gap-10"
  }, !!(updateInfo === null || updateInfo === void 0 ? void 0 : updateInfo.itemsNumber) && LayerRentals_jsx("span", {
    className: "inline-flex size-30 shrink-0 items-center justify-center rounded-full bg-success p-5 text-white"
  }, "+", updateInfo.itemsNumber), updateInfo === null || updateInfo === void 0 ? void 0 : updateInfo.message)), LayerRentals_jsx(LayerRentalsBody_LayerRentalsBody, {
    image: image,
    rentalsTree: rentalsTree
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/rentals/Rentals.jsx
var Rentals_jsx = react_default.a.createElement;



var Rentals_Rentals = function Rentals(_ref) {
  var forwardRef = _ref.forwardRef,
      image = _ref.image,
      layerName = _ref.layerName,
      rentalsTree = _ref.rentalsTree,
      title = _ref.title,
      tracking = _ref.tracking;

  if (!(rentalsTree === null || rentalsTree === void 0 ? void 0 : rentalsTree.length)) {
    return null;
  }

  var tle = title || Object(i18n["h" /* t */])('common.rentals.title');
  var imageSrc = image || Object(i18n["h" /* t */])('common.rentals.image');
  return Rentals_jsx(LayerRentals_LayerRentals, {
    forwardRef: forwardRef,
    image: imageSrc,
    layerName: layerName,
    rentalsTree: rentalsTree,
    title: tle,
    tracking: tracking
  });
};

/***/ }),

/***/ "d4In":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CapsuleCollapseLists_CapsuleCollapseLists; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.jsx + 1 modules
var CollapsePanel = __webpack_require__("gA51");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// CONCATENATED MODULE: ./src/client/components/frameworks/capsule-collapse-lists/CapsuleCollapseLists.themes.js

var themes = {
  "default": {
    thCapsuleContent: 'divide-y',
    thMessage: 'font-bold p-20 text-14',
    thCollapse: 'border-lightGrey',
    thCollapseTheme: 'limpidSmall',
    thCollapseIconCollapse: icons["a" /* ICONS */].ARROW_DOWN,
    thCollapseIconExpand: icons["a" /* ICONS */].ARROW_DOWN,
    thItems: 'pb-20 text-14',
    thItem: 'flex gap-15 items-center px-20 py-5',
    thItemIcon: 'shrink-0 text-sienna',
    thItemIconWidth: '1.5rem',
    thItemLabel: 'flex-1'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/capsule-collapse-lists/CapsuleCollapseLists.jsx

var __jsx = react_default.a.createElement;





var CapsuleCollapseLists_CapsuleCollapseLists = function CapsuleCollapseLists(_ref) {
  var className = _ref.className,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? {} : _ref$header,
      _ref$lists = _ref.lists,
      lists = _ref$lists === void 0 ? [] : _ref$lists,
      message = _ref.message,
      style = _ref.style,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!lists || !lists.length) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCapsuleContent = _themes$theme.thCapsuleContent,
      thCollapse = _themes$theme.thCollapse,
      thCollapseIconCollapse = _themes$theme.thCollapseIconCollapse,
      thCollapseIconExpand = _themes$theme.thCollapseIconExpand,
      thCollapseTheme = _themes$theme.thCollapseTheme,
      thItems = _themes$theme.thItems,
      thItem = _themes$theme.thItem,
      thItemIcon = _themes$theme.thItemIcon,
      thItemIconWidth = _themes$theme.thItemIconWidth,
      thItemLabel = _themes$theme.thItemLabel,
      thMessage = _themes$theme.thMessage;
  return __jsx(Capsule["a" /* Capsule */], {
    additionalStyle: {
      root: style
    },
    className: className,
    color: header.color,
    contentClassName: thCapsuleContent,
    header: "large",
    icon: header.iconName,
    label: header.title
  }, !!message && __jsx("p", {
    className: thMessage
  }, message), lists.map(function (el, index) {
    var _el$items;

    return !!((_el$items = el.items) === null || _el$items === void 0 ? void 0 : _el$items.length) && __jsx(CollapsePanel["a" /* CollapsePanel */], {
      className: thCollapse,
      collapseIconName: thCollapseIconCollapse,
      expandIconName: thCollapseIconExpand,
      isExpanded: index === 0,
      key: el.title,
      theme: thCollapseTheme,
      title: el.title
    }, __jsx("ul", {
      className: thItems
    }, el.items.map(function (_ref2) {
      var iconName = _ref2.iconName,
          label = _ref2.label;
      return __jsx("li", {
        className: thItem,
        key: label
      }, __jsx(Icon["a" /* Icon */], {
        className: thItemIcon,
        name: iconName,
        width: thItemIconWidth
      }), __jsx("span", {
        className: thItemLabel
      }, label));
    })));
  }));
};

/***/ }),

/***/ "gA51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CollapsePanel_CollapsePanel; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/toggler/Toggler.jsx
var Toggler = __webpack_require__("7CPK");

// CONCATENATED MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.themes.js
var themes = {
  "default": function _default() {
    return {
      thRoot: 'animate-fadeIn animation-duration-500',
      thHeader: 'border-b-1 border-lightGrey flex isolate relative',
      thHeaderDecorator: 'absolute arrow-down arrow-large arrow-white arrow-bg arrow-bg-large arrow-bg-sienna border-b-2 border-sienna -mb-1 opacity-0 bottom-0 start-0 w-full sm:w-1/5 sm:ms-25 transition-opacity duration-250 ease-in z-1',
      thHeaderDecoratorActive: 'opacity-100',
      thButton: 'flex items-center flex-1 max-w-full overflow-hidden py-20 text-initial text-black hocus:text-black-active transition-color',
      thTitle: 'flex-1 flex gap-10 items-center font-bold font-sans leading-tight max-w-full text-current text-20',
      thTitleHasEllipsis: true,
      thTitleIcon: 'text-sienna',
      thLabels: 'shrink-0 font-bold flex items-center text-14 text-sienna uppercase whitespace-nowrap',
      thLabel: 'hidden sm:inline-block',
      thLabelIcon: 'text-black transition-transform duration-250 ease-in ms-10',
      thLabelIconActive: 'transform rotate-180',
      thLabelIconWidth: '0.8125rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden shadow-inner-bottom',
      thContentInner: 'py-40'
    };
  },
  limpidSmall: function limpidSmall() {
    return {
      thRoot: 'animate-fadeIn animation-duration-500',
      thHeader: 'flex relative text-14',
      thButton: 'flex items-center flex-1 max-w-full overflow-hidden p-20 text-initial text-black',
      thTitle: 'flex flex-1 gap-5 items-center font-bold max-w-full',
      thTitleHasEllipsis: false,
      thLabels: 'shrink-0 font-bold flex items-center ms-auto text-sienna uppercase whitespace-nowrap',
      thLabel: 'underline',
      thLabelIcon: 'text-black ms-10',
      thLabelIconActive: 'transform rotate-180',
      thLabelIconWidth: '0.625rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden'
    };
  },
  homeDetails: function homeDetails() {
    return {
      thRoot: 'animate-fadeIn animation-duration-500',
      thHeader: 'flex relative',
      thButton: 'flex items-center flex-1 max-w-full overflow-hidden text-initial text-black',
      thTitle: 'flex flex-1 gap-5 items-center max-w-full text-14 font-bold',
      thTitleHasEllipsis: false,
      thTitleIcon: 'text-sienna',
      thLabels: 'shrink-0 font-bold flex items-center ms-auto text-14 text-sienna uppercase whitespace-nowrap',
      thLabel: 'underline',
      thLabelIcon: 'text-black ms-10',
      thLabelIconActive: 'transform rotate-180',
      thLabelIconWidth: '0.75rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden'
    };
  },
  remote: function remote() {
    return {
      thRoot: 'animate-fadeIn animation-duration-500 bg-white border-1 border-lightGrey rounded-12 shadow-diffuse',
      thHeader: 'flex isolate relative',
      thButton: 'flex flex-1 items-center max-w-full overflow-hidden p-15 text-initial text-black',
      thTitle: 'flex flex-1 font-semibold gap-10 items-center max-w-full',
      thTitleIcon: 'text-sienna',
      thTitleIconSize: '1.875rem',
      thLabels: 'flex items-center ms-auto shrink-0 text-14 text-black whitespace-nowrap',
      thLabelIcon: 'ms-10 text-black',
      thLabelIconActive: 'transform rotate-180',
      thLabelIconWidth: '0.625rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden',
      thInner: 'w-full'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.jsx










var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var POSITIONS = {
  BOTTOM: 'bottom',
  TOP: 'top'
};

var hasLabels = function hasLabels(_ref, isActive) {
  var collapseIconName = _ref.collapseIconName,
      collapseLabel = _ref.collapseLabel,
      expandIconName = _ref.expandIconName,
      expandLabel = _ref.expandLabel;
  return isActive ? collapseIconName || collapseLabel : expandIconName || expandLabel;
};

var CollapsePanel_LoadMoreButton = function LoadMoreButton(_ref2) {
  var ariaId = _ref2.ariaId,
      isActive = _ref2.isActive,
      isDesktop = _ref2.isDesktop,
      toggle = _ref2.toggle,
      collapsePanelProps = Object(objectWithoutProperties["a" /* default */])(_ref2, ["ariaId", "isActive", "isDesktop", "toggle"]);

  var _collapsePanelProps$a = collapsePanelProps.as,
      HeaderTag = _collapsePanelProps$a === void 0 ? 'div' : _collapsePanelProps$a,
      collapseLabel = collapsePanelProps.collapseLabel,
      _collapsePanelProps$c = collapsePanelProps.collapseIconName,
      collapseIconName = _collapsePanelProps$c === void 0 ? icons["a" /* ICONS */].CROSS : _collapsePanelProps$c,
      expandLabel = collapsePanelProps.expandLabel,
      _collapsePanelProps$e = collapsePanelProps.expandIconName,
      expandIconName = _collapsePanelProps$e === void 0 ? icons["a" /* ICONS */].ARROW_DOWN : _collapsePanelProps$e,
      _collapsePanelProps$h = collapsePanelProps.headerClassName,
      headerClassName = _collapsePanelProps$h === void 0 ? '' : _collapsePanelProps$h,
      iconName = collapsePanelProps.iconName,
      iconSize = collapsePanelProps.iconSize,
      noIcons = collapsePanelProps.noIcons,
      _collapsePanelProps$t = collapsePanelProps.theme,
      theme = _collapsePanelProps$t === void 0 ? 'default' : _collapsePanelProps$t,
      title = collapsePanelProps.title;

  var _themes$theme = themes[theme]({
    isDesktop: isDesktop
  }),
      thButton = _themes$theme.thButton,
      thHeader = _themes$theme.thHeader,
      thHeaderDecorator = _themes$theme.thHeaderDecorator,
      thHeaderDecoratorActive = _themes$theme.thHeaderDecoratorActive,
      thLabels = _themes$theme.thLabels,
      thLabel = _themes$theme.thLabel,
      thLabelIcon = _themes$theme.thLabelIcon,
      thLabelIconActive = _themes$theme.thLabelIconActive,
      thLabelIconWidth = _themes$theme.thLabelIconWidth,
      thTitle = _themes$theme.thTitle,
      thTitleHasEllipsis = _themes$theme.thTitleHasEllipsis,
      thTitleIcon = _themes$theme.thTitleIcon,
      thTitleIconSize = _themes$theme.thTitleIconSize;

  return __jsx(HeaderTag, {
    className: Object(classnames_utils["a" /* classnames */])(headerClassName, thHeader)
  }, __jsx("button", {
    "aria-controls": ariaId,
    "aria-expanded": isActive,
    className: thButton,
    onClick: toggle,
    type: "button"
  }, !!title && __jsx("span", {
    className: thTitle
  }, __jsx(Icon["a" /* Icon */], {
    className: Object(classnames_utils["a" /* classnames */])('shrink-0', thTitleIcon),
    name: iconName,
    width: iconSize || thTitleIconSize || '1em'
  }), thTitleHasEllipsis ? __jsx("span", {
    className: "w-full truncate"
  }, title) : title), hasLabels(collapsePanelProps, isActive) && __jsx("span", {
    className: thLabels
  }, __jsx("span", {
    className: thLabel,
    "data-testid": "CollapsePanel-label"
  }, isActive ? collapseLabel : expandLabel), !noIcons && __jsx(Icon["a" /* Icon */], {
    className: Object(classnames_utils["a" /* classnames */])(thLabelIcon, Object(defineProperty["a" /* default */])({}, thLabelIconActive, isActive)),
    name: isActive ? collapseIconName : expandIconName,
    width: thLabelIconWidth
  }))), (thHeaderDecorator || thHeaderDecoratorActive) && __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thHeaderDecorator, Object(defineProperty["a" /* default */])({}, thHeaderDecoratorActive, isActive))
  }));
};

var CollapsePanel_CollapsePanel = function CollapsePanel(props) {
  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(props.isExpanded),
      isVisible = _useState[0],
      setVisible = _useState[1];

  if (!react["Children"].count(props.children)) {
    return null;
  }

  var children = props.children,
      className = props.className,
      _props$hasKeepCollaps = props.hasKeepCollapsedContent,
      hasKeepCollapsedContent = _props$hasKeepCollaps === void 0 ? true : _props$hasKeepCollaps,
      id = props.id,
      isExpanded = props.isExpanded,
      isSemiTransparent = props.isSemiTransparent,
      _props$loadMoreButton = props.loadMoreButtonPosition,
      loadMoreButtonPosition = _props$loadMoreButton === void 0 ? POSITIONS.TOP : _props$loadMoreButton,
      onClick = props.onClick,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      title = props.title;

  var _themes$theme2 = themes[theme]({
    isDesktop: isDesktop
  }),
      thBody = _themes$theme2.thBody,
      thCollapsedTagInitialStyle = _themes$theme2.thCollapsedTagInitialStyle,
      thContent = _themes$theme2.thContent,
      thContentInner = _themes$theme2.thContentInner,
      thRoot = _themes$theme2.thRoot;

  var ariaId = Object(uniqueId["b" /* generateUniqueId */])([id || title || ''], 'CollapsePanel_');
  var CollapsedTag = hasKeepCollapsedContent ? lib["Collapse"] : lib["UnmountClosed"];
  return __jsx(Toggler["a" /* Toggler */], {
    isActive: isExpanded,
    onToggle: onClick
  }, function (toggle, isActive) {
    return __jsx("section", {
      className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
      id: id
    }, loadMoreButtonPosition === POSITIONS.TOP && __jsx(CollapsePanel_LoadMoreButton, Object(esm_extends["a" /* default */])({}, props, {
      ariaId: ariaId,
      isActive: isActive,
      isDesktop: isDesktop,
      toggle: toggle
    })), __jsx("div", {
      "aria-hidden": !isActive,
      className: Object(classnames_utils["a" /* classnames */])(thBody, {
        invisible: !isVisible
      }),
      id: ariaId
    }, __jsx(CollapsedTag, {
      initialStyle: isSemiTransparent ? _objectSpread({
        height: 'auto',
        overflow: 'initial'
      }, thCollapsedTagInitialStyle) : thCollapsedTagInitialStyle,
      isOpened: isActive,
      onWork: function onWork() {
        setVisible(true);
      },
      onRest: function onRest(_ref3) {
        var isFullyClosed = _ref3.isFullyClosed;
        setVisible(!isFullyClosed);
      }
    }, __jsx("div", {
      className: thContent
    }, __jsx("div", {
      className: thContentInner
    }, children)))), loadMoreButtonPosition === POSITIONS.BOTTOM && __jsx(CollapsePanel_LoadMoreButton, Object(esm_extends["a" /* default */])({}, props, {
      ariaId: ariaId,
      isActive: isActive,
      isDesktop: isDesktop,
      toggle: toggle
    })));
  });
};

/***/ })

}]);